export default  {
  bindings: {
    availability: '=',
    title: '@',
    events: '<',
    categories: '<'
  },
  controller: 'availabilitySaveController',
  template: require('../views/availability.save.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/availability/components/availability.save.component.js